import { create } from 'zustand'

interface PageTitleState {
	pageTitle: string | null
	setPageTitle: (title: string | null) => void
}

export const usePageTitleStore = create<PageTitleState>((set) => ({
	pageTitle: null,
	setPageTitle: (pageTitle) => set({ pageTitle }),
}))
